import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  PluginListUrlQueryParams,
  PluginListUrlSortField,
  PluginUrlQueryParams
} from "./urls";
import PluginsListComponent from "./views/PluginList";
import PluginsDetailsComponent from "./views/PluginsDetails";

const PluginList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    PluginListUrlSortField
  ) as PluginListUrlQueryParams;
  return <PluginsListComponent params={params} />;
};

const PluginDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<PluginUrlQueryParams>(
    location.search.substr(1)
  );

  return (
    <PluginsDetailsComponent id={decodeURIComponent(id)} params={params} />
  );
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.plugins)} />
      <Routes>
        <Route path={""} element={<PluginList />} />
        <Route path={":id"} element={<PluginDetails />} />
      </Routes>
    </>
  );
};

export default Component;
